import { NodeScanner } from "@/components/node/NodeScanner.tsx";
import { Node as NodeType } from "@/lib/types/node.ts";
import { ActionIcon } from "@mantine/core";
import { FaPencil, FaRaspberryPi } from "react-icons/fa6";
import { CardGray } from "../atoms/CardGray";

type Props = {
  node: NodeType,
  onEdit: (node: NodeType) => void;
  onDelete: (node: NodeType) => void;
}

export const Node = ({ node, onEdit }: Props) => {
  return (
    <CardGray id={`node-${node.id}`} className="flex flex-col gap-4 justify-between">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <FaRaspberryPi />
          <span className="font-bold">{node.name}</span>
        </div>
      </div>
      <div className="grid grid-cols-[max-content_1fr] items-center space-x-4 text-sm text-muted">
        <div>MAC</div>
        <div>{node.mac}</div>
      </div>
      {node.scanners.length > 0 ? (
        <div className="grid 2xl:grid-cols-2 gap-2">
          {node.scanners.map(s => <NodeScanner key={s.id} scanner={s} />)}
        </div>
      ) : (
        <span className="text-center text-muted">No scanners connected</span>
      )}
      <div className="flex gap-2 justify-end">
        <ActionIcon variant="transparent" color="black" onClick={() => onEdit(node)}>
          <FaPencil />
        </ActionIcon>
      </div>
    </CardGray>
  )
}
